import mock from "./mock";
import "./navbar/navbarSearch";
import "./navbar/navbarBookmarkSearch";
mock.onAny().passThrough();
